import { useForumType } from '@/components/hooks/useForumType';
import React from 'react';

// -- See here for all the tab content --
import getMenuTabs from './menuTabs'
import { forumSelect } from '../../../lib/forumTypeUtils';
import TabNavigationCompressedItem from "./TabNavigationCompressedItem";
import SimpleDivider from "../../widgets/SimpleDivider";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles("TabNavigationMenuCompressed", (theme: ThemeType) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width:55,
    backgroundColor: theme.palette.grey[100],
    borderRight: theme.palette.border.faint,
    height:"100%",
    color: theme.palette.grey[600],
  },
  divider: {
    marginTop:8,
    marginBottom:8
  }
}))

const TabNavigationMenuCompressed = ({onClickSection}: {
  onClickSection: (e?: React.BaseSyntheticEvent) => void,
}) => {
  const { forumType } = useForumType();
  const classes = useStyles(styles);
  return (
    <div className={classes.root}>
      {forumSelect(getMenuTabs(), forumType).map(tab => {
        if (!('showOnCompressed' in tab) || !tab.showOnCompressed) {
          return
        }
        if ('divider' in tab) {
          return <SimpleDivider key={tab.id} className={classes.divider} />
        }
        return <TabNavigationCompressedItem key={tab.id} tab={tab} onClick={onClickSection} />
      })}
    </div>
  )
};

export default TabNavigationMenuCompressed;


